import { isNil } from 'lodash';
import { useContext } from 'react';

import { CardFormContext } from '@shared/components/blocks/contexts/form';
import { ReferencedInEditField } from '@shared/scenes/entity/components/fields/ReferencedInEditField';
import { isReferencedInComponent } from '@shared/scenes/workflows/utils';
import { WorkflowComponentProps } from './WorkflowComponent';

export function WorkflowReferencedInComponent({ component }: WorkflowComponentProps) {
  const { card } = useContext(CardFormContext);

  if (isNil(card?.id) || !isReferencedInComponent(component)) {
    return null;
  }

  return <ReferencedInEditField component={component} entityId={card.id} />;
}
